import { connect } from 'react-redux';
import { Action, bindActionCreators } from 'redux';
import {
    changeMetricPosition,
    changeSegmentation,
    toggleMetricActive,
    resetToInitialMetrics,
    setInitialMetrics,
} from './metrics-report.state';
import {
    metricsReportType, positionMetricType, Metric, Metrics,
} from './metrics-report.types';


export interface WithMetricsReport {
    metricsReport: metricsReportType;
    changeSegmentation: (segmentation: string) => Action;
    changeMetricPosition: (metric: Metric, metricPosition:positionMetricType) => Action;
    toggleMetricActive: (metricPosition:positionMetricType) => Action;
    setInitialMetrics: (metrics: Metrics) => Action;
}

export const withMetricsReport = connect(
    state => ({
        metricsReport: state.dashboard.metricsReport,
    }),
    dispatch => bindActionCreators({
        changeSegmentation,
        changeMetricPosition,
        toggleMetricActive,
        resetToInitialMetrics,
        setInitialMetrics,
    }, dispatch),
);
